<template>
  <div>
    <div v-if="!componentIsLoading">
      <div v-if="orders.length > 0">
        <order-payment-modal v-if="showModal" 
                            @cancel="toggleModal(false)" 
                            :order="orderForModal" 
                            @close-after-sucess="handleSuccess" 
                            @payment-refused="fetchOrders()" 
                            @close="debouncedHandleSucess">
        </order-payment-modal>
  
        <auth-capture-modal modal-id="authCaptureModal"
          modal-title="Capturer une autorisation bancaire"
          v-if="authCaptureModalDisplayed"
          @modal-closed="onAuthCaptureModalClosed"
        >
          <p>Merci de vérifier si le client n'a pas déjà été prélevé avant de capturer l’autorisation.</p>
  
          <div style="margin-top: 20px;">
            <button type="button" class="btn btn-primary btn-sm" @click="performAuthCapture">Valider</button>
            <button type="button" class="btn btn-default btn-sm" @click="onAuthCaptureModalClosed">Annuler</button>
          </div>
        </auth-capture-modal>
        
        <auth-cancelation-modal modal-id="authCaptureModal"
          modal-title="Annuler une autorisation bancaire"
          v-if="authCancelModalDisplayed"
          @modal-closed="onAuthCancelModalClosed"
        >
          <p>
            En validant, la commande va être considérée comme étant déjà réglée par un autre moyen (prélevement, …). 
            <br><br>L'autorisation bancaire restée en attente sera détruite.
          </p>
  
          <div style="margin-top: 20px;">
            <button type="button" class="btn btn-primary btn-sm" @click="performAuthCancelation">Valider</button>
            <button type="button" class="btn btn-default btn-sm" @click="onAuthCancelModalClosed">Annuler</button>
          </div>
        </auth-cancelation-modal>
  
        <!-- Tab panes -->
        <div class="tab-pane slide-left active" id="slide2">
  
            <!-- BEGIN Customers Table-->
            <div class="container-fluid orders-table">
                <!--<span>
                          <strong>suggestions :</strong>
                      </span>
                    <span id="overlay-suggestions"></span>
                    <br>-->
                <div>
                    <!--<p class="bold">Pages Search Results</p>-->
                    <div class="row">
                        <div class="col-md-12">
                            <!-- START PANEL -->
                            <div class="panel panel-transparent m-b-0">
                                <div class="panel-body">
  
                                    <div>
                                        <table id="detailedTable" class="table table-condensed table-responsive">
                                            <thead>
                                              <!-- <tr>
                                                <th class="v-align-middle">Numéro</th>
                                                <th class="v-align-middle">Date</th>
                                                <th class="v-align-middle">Produit</th>
                                                <th class="v-align-middle">Montants</th>
                                                <th class="v-align-middle">État</th>
                                                <th class="v-align-middle">Apporteur d'affaires</th>
                                                <th class="v-align-middle"></th>
                                              </tr> -->
                                                <tr>
                                                    <th class="v-align-middle">Date</th>
                                                    <th class="v-align-middle">Type</th>
                                                    <th class="v-align-middle">Numéro</th>
                                                    <th class="v-align-middle">Montant</th>
                                                    <th class="v-align-middle">Statut paiement</th>
                                                    <th class="v-align-middle text-center">Apporteur d'affaires</th>
                                                    <th class="v-align-middle text-center">Payeur</th>
                                                    <th class="v-align-middle text-center">Code promo</th>
                                                    <th class="v-align-middle text-right"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                              <template v-for="(order, idx) in orders">
                                                <item 
                                                  :key="'order-' + idx"
                                                  :ref="'orderItem' + order.id"
                                                  :order="order" 
                                                  @toggle-order-detail="toggleDetails($event)" 
                                                  @toggle-payment-modal="toggleModal" 
                                                  @capture-authorization="handleAuthCaptureRequest"
                                                  @cancel-authorization="handleAuthCancelationRequest"
                                                ></item>
                                                <!-- <item-details :order="order" :key="'order-details' + idx" v-if="toggledDetails(order.id)"></item-details> -->
                                                <item-details :order="order" :suborders="order.suborders" :key="'order-details' + idx" v-if="toggledDetails(order.id)"></item-details>
                                              </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END Customers Table !-->
            </div>
        </div>
      </div>
  
      <div v-else>
        <hr>
        
        <div class="alert alert-info">
            <i class="fa fa-info-circle"></i> Le client n'a encore passé aucune commande
        </div>
      </div>
    </div>

    <component-loader v-else></component-loader>
  </div>
</template>

<style lang="scss" scoped>
    .orders-table {
        padding: 0;
    }

    .panel-body {
        min-width: 600px;
        padding: 0;
    }

    .search-table {
        th {
            width: auto;
            &:first-child {
                width: 10px;
            }
            &:last-child {
                width: 113px;
            }
        }
    }

    .pagination {
        padding: 0;
        float: right;
    }

    .pagination ul {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }

    .pagination li {
        display: inline-block;
        padding: 5px 18px;
        color: #222;
    }

    .p12 li:first-of-type,
    .p12 li:last-of-type,
    .p12 .is-active {
        background-color: #fb557a;
        color: #fff;
        border-radius: 3px;
    }
</style>

<script type="text/babel">
    import {mapState, mapActions} from 'vuex'
    import Item from './OrdersTabContent/Item'
    import ItemDetails from "./OrdersTabContent/ItemDetails"
    import OrderPaymentModal from "./OrdersTabContent/OrderPaymentModal"
    import authCaptureModal from 'components/Modals/FillInModal'
    import authCancelationModal from 'components/Modals/FillInModal'
    import ComponentLoader from 'components/ComponentLoader'

    export default {

        name: "OrdersTab",

        components: {
            Item,
            ItemDetails,
            OrderPaymentModal,
            authCaptureModal,
            authCancelationModal,
            ComponentLoader
        },

        mounted () {
            this.toggleDetails(this.$store.state.customer.highlighted_order)
        },

        methods:{
          ...mapActions("demands", ['getPaymentMethods', 'captureAutorizations', 'cancelAuthorizations']),
          ...mapActions("customer", ['fetchOrders']),
          ...mapActions('invoices', ['fetchInvoices']),

          toggleDetails(event) {
            if (event)
            {
              if (_.find(this.toggled_details, order => order == event) != undefined)
                  this.toggled_details = _.filter(this.toggled_details, order => order != event)
              else {
                  this.toggled_details.push(event)
              }
            }
          },

          toggledDetails(order_id) {
              return _.find(this.toggled_details, orderId => orderId == order_id) != undefined
          },

          toggleModal(event) {
              if (event)
              {
                this.orderForModal = event
                this.showModal = true
              }
              else {
                this.orderForModal = null
                this.showModal = false
              }
          },

          handleSuccess(){
            this.toggleModal(false)
            this.fetchOrders()
          },

          handleAuthCaptureRequest(event) {
            if (event && typeof event === 'object' && event.hasOwnProperty('id') && event.hasOwnProperty('payment_status')) {
              this.authToCaptureOrderId = event.id

              if ('paid' === event.payment_status) {
                this.authCaptureModalDisplayed = true
              } else {
                this.performAuthCapture()
              }
            }
          },

          performAuthCapture() {
            const vm = this

            this.$refs[`orderItem${this.authToCaptureOrderId}`][0].captureButtonDisabled = true

            this.captureAutorizations(this.authToCaptureOrderId)
              .then(function () {
                vm.$refs[`orderItem${vm.authToCaptureOrderId}`][0].captureButtonDisabled = false

                vm.fetchOrders().then(() => vm.onAuthCaptureModalClosed())
              })
          },

          onAuthCaptureModalClosed() {
            this.authToCaptureOrderId = null
            this.authCaptureModalDisplayed = false
          },
          
          handleAuthCancelationRequest(event) {
            if (event && typeof event === 'object' && event.hasOwnProperty('id') && event.hasOwnProperty('payment_status')) {
              this.authToCancelOrderId = event.id
              this.authCancelModalDisplayed = true
            }
          },

          performAuthCancelation() {
            const vm = this

            this.$refs[`orderItem${this.authToCancelOrderId}`][0].cancelButtonDisabled = true

            this.cancelAuthorizations(this.authToCancelOrderId)
              .then(function () {
                vm.$refs[`orderItem${vm.authToCancelOrderId}`][0].cancelButtonDisabled = false

                vm.fetchOrders().then(() => vm.onAuthCancelModalClosed())
              })
          },

          onAuthCancelModalClosed() {
            this.authToCancelOrderId = null
            this.authCancelModalDisplayed = false
          }
        },

        created() {
          const vm = this

          this.fetchInvoices(this.customerId)
            .then(function () {
              vm.fetchOrders()
                .then(() => vm.componentIsLoading = false)
            })
          
          this.debouncedHandleSucess = _.debounce(this.handleSuccess, 3000)
        },

        computed:{
          ...mapState("customer", {
              orders: 'orders',
              customerId: 'id'
          }),
          ...mapState("demands", ['payment_methods', 'capture_authorizations', 'cancel_authorizations']),

          get_all_payments_methods(){
            var tmp = this.orderForModal
            if (tmp != null && tmp != undefined && tmp != false)
              {
                this.getPaymentMethods({order_id:tmp.id})
                return true
              }
            return false
          },
        },

        data() {
          return {
            componentIsLoading: true,
            toggled_details:[],
            showModal:false,
            orderForModal:null,
            debouncedHandleSucess:null,
            authToCaptureOrderId: null,
            authCaptureModalDisplayed: false,
            authToCancelOrderId: null,
            authCancelModalDisplayed: false,
          }
        },

        watch: {
            capture_authorizations(newValue, oldValue) {
              let response = newValue.response
              let type, message, timeout

              if (response.data.data.status == 'success') {
                if (response.data.data.captured_authorization_nb > 0) {
                  type = 'complete-success'
                  message = response.data.data.captured_authorization_nb + ' autorisation(s) capturée(s) avec succès'
                } else {
                  type = 'info'
                  message = 'Aucune autorisation capturée'
                }

                timeout = 5000
              } else {
                type = 'error'
                message = 'La capture des autorisations a échoué: code d\'erreur ' + response.data.data.error_code
                if (response.data.data.error_message && response.data.data.error_message.length > 0) {
                  message += ' - ' + response.data.data.error_message
                }
                
                timeout = 0
              }

              $('body').pgNotification({
                style: 'bar',
                type: type,
                message: message,
                timeout: timeout,
              }).show()
            },
            cancel_authorizations(newValue, oldValue) {
              let response = newValue.response
              let type, message, timeout

              if (response.data.data.status == 'success') {
                type = 'complete-success'
                message = 'Autorisation(s) annulées(s) avec succès'

                timeout = 5000
              } else {
                type = 'error'
                message = 'L\'annulation des autorisations a échoué: code d\'erreur ' + response.data.data.error_code
                if (response.data.data.error_message && response.data.data.error_message.length > 0) {
                  message += ' - ' + response.data.data.error_message
                }
                
                timeout = 0
              }

              $('body').pgNotification({
                style: 'bar',
                type: type,
                message: message,
                timeout: timeout,
              }).show()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/components/Customer/OrdersTab.vue